import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-mission',
  templateUrl: './mission.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mission.component.scss']
})
export class MissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
